<div class="session-timeout-container">
    <!-- Close Button (Positioned Top-Right) -->
    <button mat-icon-button class="close-button" (click)="onCancel()">
        <mat-icon>close</mat-icon>
    </button>

    <div class="timeout-header">
        Session Timeout (minutes)
    </div>

    <div class="timeout-settings" [formGroup]="sessionTimeoutForm">
        <div class="timeout-field">
            <label>Operator</label>
            <mat-form-field appearance="outline">
                <input matInput type="number" formControlName="operatorTimeout" min="1" />
            </mat-form-field>
        </div>

        <div class="timeout-field">
            <label>Analyst</label>
            <mat-form-field appearance="outline">
                <input matInput type="number" formControlName="analystTimeout" min="1" />
            </mat-form-field>
        </div>

        <div class="timeout-field">
            <label>Admin</label>
            <mat-form-field appearance="outline">
                <input matInput type="number" formControlName="adminTimeout" min="1" />
            </mat-form-field>
        </div>

        <button type="button" mat-raised-button color="primary" class="save-btn" (click)="saveTimeouts()">Save</button>
    </div>
</div>
